// extracted by mini-css-extract-plugin
export default {"link":"zgrtTC","container":"p8yPiB"};